import { useEffect, useState } from 'react'
import { UserOutlined } from '@ant-design/icons'
import { FormDrawer } from '../../common'
import ProfilePageForm from './profile-page-form'
import { globalConfig } from '../../configuration/config'
import { API_URLs } from '../../configuration/api-urls'
import { IProfileItems } from '../../pages/constants'

export const ProfilePage = () => {
  const [isFormDrawerOpen, setIsFormDrawerOpen] = useState<boolean>(false)

  const [isFormSelected, setIsFormSelected] = useState<boolean>(true)

  const [profileData, setProfileData] = useState<IProfileItems>()

  const ToggleIsFormDrawerOpen = () => {
    setIsFormDrawerOpen((prev) => !prev)
  }

  const toggleForm = () => {
    setIsFormSelected(true)
    setIsFormDrawerOpen(true)
  }

  const getProfileFetchUrl = globalConfig
    .get()
    .apiBaseUrl.concat(API_URLs.v1.GET_Profile)

  const postProfileFetchUrl = globalConfig
    .get()
    .apiBaseUrl.concat(API_URLs.v1.POST_Profile)

  useEffect(() => {
    const profile = {
      peerContactNumber: '',
      peerEmail: '',
      peerName: '',
    }
    const fetchProfile = async () => {
      const encryptedToken = sessionStorage.getItem('encryptedToken') || ''
      const encryptedAESKey = sessionStorage.getItem('encryptedAESKey') || ''
      try {
        const response = await fetch(getProfileFetchUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            EncryptedAESKey: encryptedAESKey,
            EncryptedToken: encryptedToken,
          },
        })
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        setProfileData(data ? data : profile)
      } catch (error) {
        console.error('Error fetching profile:', error)
        createProfile()
      }
    }

    const createProfile = async () => {
      try {
        const encryptedToken = sessionStorage.getItem('encryptedToken') || ''
        const encryptedAESKey = sessionStorage.getItem('encryptedAESKey') || ''
        const response = await fetch(postProfileFetchUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            EncryptedAESKey: encryptedAESKey,
            EncryptedToken: encryptedToken,
          },
          body: JSON.stringify({}),
        })
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        setProfileData(data ? data : profile)
      } catch (error) {
        console.error('Error creating profile:', error)
        // Handle the error (show message to the user, etc.)
      }
    }

    fetchProfile()
  }, [])

  const updatePhoneNumber = (newPhoneNumber: any) => {
    setProfileData((prevData) => {
      if (!prevData) {
        return {
          peerContactNumber: newPhoneNumber,
          peerEmail: '',
          peerName: '',
        }
      }
      return {
        ...prevData,
        peerContactNumber: newPhoneNumber,
      }
    })
  }

  return (
    <div>
      <div
        className="flex flex-row justify-start items-center text-start gap-2 m-2"
        onClick={toggleForm}
      >
        <UserOutlined className="stroke-2" />
        <div className="text-start text-sm font-barlow">Profile</div>
      </div>
      {
        <FormDrawer
          title={'Your Profile'}
          child={
            isFormSelected ? (
              <ProfilePageForm
                onClose={ToggleIsFormDrawerOpen}
                isVisible={isFormDrawerOpen}
                data={profileData}
                updatePhoneNumber={updatePhoneNumber}
              />
            ) : null
          }
          isOpen={isFormDrawerOpen}
          onClose={ToggleIsFormDrawerOpen}
          isProfilePage={true}
        />
      }
    </div>
  )
}
